// Formatear número con punto como separador de miles (es-CL)
export const formatearMonto = (valor: string): string => {
  const numero = valor.replace(/\D/g, '');
  if (!numero) return '';
  return parseInt(numero).toLocaleString('es-CL');
};

// Obtener valor numérico sin formato
export const obtenerValorNumerico = (valorFormateado: string): number => {
  const numero = valorFormateado.replace(/\./g, '');
  return parseInt(numero) || 0;
};
